import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { Details, Poll, Stats } from "../../tools/interfaces";

import API from '../../tools/API';
import styles from "./Statistics.module.scss";

const Statistics = () => {
    const { id } = useParams();
    const [poll, setPoll] = useState<Poll | null>(null);
    const [votingStats, setVotingStats] = useState<Stats | null>(null);
    const [votingDetails, setVotingDetails] = useState<[] | null>(null);

    useEffect(() => {
        API.getSinglePoll(id as string).then((res) => {
            setPoll(res?.data.data);
        })
        API.getVotingStats(id as string).then(res => {
            if (res) {
                setVotingStats(res.data.data);
            }
        })
        API.getVotingDetails(id as string).then(res => {
            if (res) {
                setVotingDetails(res.data.data);
            }
        })
    }, []);

    const rankUp = () => {
        return <div className={styles.rankUp}></div>
    }

    const rankDown = () => {
        return <div className={styles.rankDown}></div>
    }

    return (
        <section className={styles.statsContainer}>
            {poll &&
                <div className={styles.topRow}>
                    <h2 className={styles.pollName}>{poll?.name}</h2>
                    <div className={styles.statsWrapper}>
                        <p className={styles.votingStats}>Głosowało użytkowników: {votingStats?.usersCount}</p>
                        <p className={styles.votingStats}>Łącznie głosów: {votingStats?.totalVotes}</p>
                    </div>
                </div>
            }
            {votingDetails &&
                <div className={styles.detailsWrapper}>
                    <ul className={styles.detailsList}>
                        {votingDetails.map((el: Details, index: number) => {
                            return (
                                <li key={index} className={styles.listElement}>
                                    <div className={styles.rankBox}>
                                        <p className={styles.place}>Miejsce</p>
                                        <h4 className={styles.ranking}>{el.rank}.</h4>
                                    </div>
                                    <div className={styles.dataBox}>
                                        <div className={styles.title}>
                                            <p>{el.artist} - {el.title}</p>
                                        </div>
                                        <div className={styles.scores}>
                                            <p>Wynik:&nbsp;
                                                <span style={{ color: "#555454" }}>{el.score}%</span>
                                            </p>
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <p>Liczba głosów:</p>
                                                <div className={styles.voteIcon}></div>
                                                <span style={{ color: "#555454" }}>
                                                    {el.numberOfVotes}
                                                </span>
                                            </div>
                                        </div>
                                        <div className={styles.rank}>
                                            {el.tag ?
                                                <div className={styles.tag}>
                                                    <p>Tag: <span style={{ color: "#555454" }}>{el.tag}</span></p>
                                                </div>
                                                : <div></div>
                                            }
                                            <div style={{ display: "flex", alignItems: "center" }}>
                                                <p>Poprzednie miejsce:&nbsp;</p>
                                                <div style={{ display: "flex", alignItems: "center" }}>
                                                    <span style={{ color: "#555454" }}>
                                                        {el.previousRank}
                                                    </span>
                                                    {el.trend &&
                                                        <span style={{
                                                            color: el.trend?.includes("-") ? "red" : "#17bf0b",
                                                            fontWeight: "700",
                                                            display: "flex",
                                                            alignItems: "center"
                                                        }}>
                                                            &nbsp;{el.trend?.charAt(0) === '+' ? rankUp() : rankDown()}
                                                            {el.trend.slice(1)}
                                                        </span>
                                                    }
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </li>
                            )
                        })
                        }
                    </ul>
                </div>

            }
        </section>
    )
}

export default Statistics;